{
  "blocks": [
    {
      "id": "module-genetic-carrier",
      "kind": "module",
      "tags": ["both-partners", "testing", "genetic-screening"],
      "title": "Genetic Carrier Screening",
      "subtitle": "Carrier panel for inherited conditions: not a full genome, but essential for family planning",
      "icon": "🧬",
      "body": {
        "duration": "4–8 weeks",
        "category": "testing",
        "forWhom": "both",
        "includes": [
          "Expanded carrier panel (200+ conditions) via blood or saliva",
          "Both-partner screening for recessive conditions",
          "Genetic counselor consultation to review results",
          "Actionable guidance if both partners are carriers for the same condition",
          "Implications for PGT-M (preimplantation genetic testing for monogenic disorders)"
        ],
        "priceRange": {
          "low": 250,
          "high": 1500
        },
        "currency": "USD",
        "status": "coming-soon",
        "steps": [
          {
            "title": "Sample collection",
            "description": "Simple blood draw or saliva kit for each partner. Can be done at a lab or at home."
          },
          {
            "title": "Lab processing",
            "description": "Genetic analysis typically takes 2–4 weeks. Screens for cystic fibrosis, SMA, fragile X, and 200+ conditions."
          },
          {
            "title": "Results & counseling",
            "description": "Genetic counselor reviews findings. If both partners carry the same condition, discusses PGT-M and other options."
          }
        ]
      },
      "sources": [
        {
          "title": "Carrier screening for genetic conditions: ACOG committee opinion",
          "journal": "Obstetrics & Gynecology",
          "year": 2023,
          "evidenceLevel": "expert-opinion"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
